import React from "react";

import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import styled from "styled-components";

import PageLayout from "Components/PageLayout";
import PageMeta from "Components/PageMeta";
import NavBar from "Containers/NavBar";

const HorizontalDivider = styled.div`
  width: 100%;
  background-color: var(
    --horizontal-divider-section-background-color,
    var(--section-transparent-background-color, var(--transparent))
  );
  height: var(
    --horizontal-divider-section-height,
    var(--section-0px-height, var(--0px))
  );
`;

const OrganizationSettings = ({ children }) => {
  const intl = useIntl();
  const { organizationId, projectId } = useParams();

  return (
    <>
      <PageMeta title={intl.formatMessage({ id: "billing.documenttitle" })} />
      <NavBar projectId={projectId} organizationId={organizationId} />

      <HorizontalDivider />
      <PageLayout>{children}</PageLayout>
    </>
  );
};

OrganizationSettings.propTypes = {
  children: PropTypes.node
};

export default OrganizationSettings;
